module.exports = __webpack_public_path__ + "static/media/help.ab6ba349.svg";